<template>
  <su-page>
    <el-row class="flex al-cn ju-sp mt30" slot="content">
<!--      v-if="token"-->
      <div class="testSiteApplication">
        <el-form ref="formData" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input type="number" v-model="form.mobile" placeholder="请输入电话号码"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="firm">
            <el-input v-model="form.firm" placeholder="请输入单位名称"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="remark">
            <el-input type="textarea" v-model="form.remark" placeholder="请输入备注信息"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('formData')">提交</el-button>
            <el-button @click="resetForm('formData')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
<!--      <div class="testSiteApplication" v-else>
        <el-empty description="请登录后操作"></el-empty>
      </div>-->
    </el-row>
  </su-page>
</template>
<script>


import {apply} from "@/api/api";
import {mapState} from "vuex";

export default {
  name: "examPoint",
  data() {
    return {
      form: {
        name: '',
        mobile: '',
        firm: '',
        remark: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入电话号码', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (!(/^1[3456789]\d{9}$/.test(value))) {
                callback(new Error('请输入正确的手机号码'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        firm: [
          {required: true, message: '请输入单位名称', trigger: 'blur'}
        ],
        remark: [
          {required: true, message: '请输入备注信息', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  mounted() {

  },
  created() {

  },
  methods: {
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apply(this.form).then(res => {
            if (res.status === 200) {
              this.$message.success('提交成功');
              this.resetForm('formData'); // 重置表单
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    }
  }
}
</script>

<style scoped lang="scss">
@media (min-width: 750px) {
  .testSiteApplication {
    width: 50%;
  }
}

@media (max-width: 750px) {
  .testSiteApplication {
    width: 100%;
  }
}
</style>
